import { render, staticRenderFns } from "./PrePrimary.vue?vue&type=template&id=4084bff0"
import script from "./PrePrimary.vue?vue&type=script&lang=js"
export * from "./PrePrimary.vue?vue&type=script&lang=js"
import style0 from "./PrePrimary.vue?vue&type=style&index=0&id=4084bff0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports